export default __webpack_public_path__ + "static/media/plan-image.9cef4640.png";